<a [routerLink]="moreRouterLink" [queryParams]="moreQueryParams" class="more__wrapper">
  <mat-card class="more">
    <div i18n="@@uiElements-moreCard-text">Mehr<br /><span>entdecken</span></div>
    <div class="more__indicator">
      <mat-icon>arrow_right_alt</mat-icon>
    </div>
  </mat-card>
</a>
